/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
// TODO
import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import ErrorMessage from './errorMessage';

// raido should have radioGroupName
// item must have fields, label and value
class HHSingleSelectLightBtn extends Component {
  render() {
    const {
      translate,
      field,
      form: { touched, errors, setFieldValue }

    } = this.props;

    // const { items, radioGroupName, ...restOtherProps } = otherProps;
    const hasError = !!(touched[field.name] && errors[field.name]);

    const handleYesOnClick = e => {
      e.preventDefault();
      setFieldValue(field.name, btnValues[0]);
    };
    const handleNoOnClick = e => {
      e.preventDefault();
      // eslint-disable-next-line no-use-before-define
      setFieldValue(field.name, btnValues[1]);
    };

    let labels = [];
    let btnValues = [true, false];
    if (field.name === 'isOnline') {
      labels = [translate('eventBtnOnline'), translate('eventBtnOffline')];
    } else if (field.name === 'type') {
      labels = [translate('eventBtnFree'), translate('eventBtnTicket')];
      btnValues = ['FREE', 'TICKET'];
    } else if (field.name === 'isPrivate' || field.name === 'isNotWillingToPublic') {
      labels = [translate('eventBtnPrivate'), translate('eventBtnPublic')];
    } else {
      labels = [translate('eventBtnYes'), translate('eventBtnNo')];
    }
    const btnOneActive = field.value === true || field.value === 'FREE';
    const btnTwoActive = field.value === false || field.value === 'TICKET';

    if (field.name === 'isOnline') {
      const handleOnClick = (e, { value }) => {
        e.preventDefault();
        setFieldValue(field.name, value);
      };
      const onlineActive = field.value === 'online';
      const offlineActive = field.value === 'offline';
      const hybridActive = field.value === 'hybrid';
      return (
        <div className='single-select-field'>
          <StyledButton onClick={handleOnClick} value='online' className={onlineActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{labels[0]}</StyledButton>
          <StyledButton onClick={handleOnClick} value='offline' className={offlineActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{labels[1]}</StyledButton>
          <StyledButton onClick={handleOnClick} value='hybrid' className={hybridActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{translate('eventBtnHybrid')}</StyledButton>
          {hasError && <ErrorMessage error={errors[field.name]} />}
        </div>
      );
    }

    if (field.name === 'isNotWillingToPublic') {
      const handleYesOnClick = e => {
        e.preventDefault();
        setFieldValue(field.name, btnValues[0]);
        setFieldValue('isPrivate', true);
      };
      const handleNoOnClick = e => {
        e.preventDefault();
        // eslint-disable-next-line no-use-before-define
        setFieldValue(field.name, btnValues[1]);
        setFieldValue('isPrivate', false);
      };

      return (
        <div className='single-select-field'>
          <Button onClick={handleYesOnClick} value={btnValues[0]} className={btnOneActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{labels[0]}</Button>
          <Button onClick={handleNoOnClick} value={btnValues[1]} className={btnTwoActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{labels[1]}</Button>
          {hasError && <ErrorMessage error={errors[field.name]} />}
        </div>
      );
    }

    return (
      <div className='single-select-field'>
        <Button onClick={handleYesOnClick} value={btnValues[0]} className={btnOneActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{labels[0]}</Button>
        <Button onClick={handleNoOnClick} value={btnValues[1]} className={btnTwoActive ? 'single-select-btn__selected' : 'single-select-btn__unselected'}>{labels[1]}</Button>
        {hasError && <ErrorMessage error={errors[field.name]} />}
      </div>
    );
  }
}

const StyledButton = styled(Button)`
  &&&.ui.button {
    border: 1px solid transparent;
  }
`;

export default withLocalize(HHSingleSelectLightBtn);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhSingleSelectLightBtn.js